import React, {useEffect, useRef, useState} from 'react';
import PrevNextButtons from "../../components/PrevNextButtons";
import InputComponent from "../../components/InputComponent";
import SelectComponent from "../../components/SelectComponent";
import {cities} from "../../values/me";
import SwitchComponent from "../../components/SwitchComponent";
import {Button, Divider, Form, notification, Tooltip} from "antd";
import {CalcData} from "../../model/clases/CalcData";
import {TemplatesEnum} from "../../model/enums/TemplatesEnum";
import {util} from "../../core/utils";
import {MailData} from "../../model/clases/MailData";
import {api} from "../../core/api";

import Loading from "../../model/enums/Loading";
import {CloseCircleOutlined, ExclamationCircleOutlined, FileImageOutlined} from "@ant-design/icons/lib";
import CodeData from "../../model/clases/CodeData";

interface StepThreeProps {
  current: number
  steps: number
  initial?: CalcData;
  calc: number;

  handleLoader?(isLoading: Loading): void;

  prev(): void

  next(): void

  handleFinish(value: any): void
  onPhoto(file: any): void
  handleConsent(e:boolean):void

}

const StepThree = ({current, steps, prev, handleFinish, initial, calc, handleLoader, onPhoto, handleConsent}: StepThreeProps) => {
  const [isSame, setIsSame] = useState<boolean>(false);
  const [mailData, setMailData] = useState<MailData>(new MailData());
  const [mailResponse, setMailResponse] = useState<any>();
  const [codedata, setCodedata] = useState<CodeData>(new CodeData());
  const [verified, setVerified] = useState<boolean>(false);
  const [requiredPhoto, setRequiredPhoto] = useState<boolean>(true);
  const [requiredSerial, setRequiredSerial] = useState<boolean>(true);
  useEffect(() => {
    util.screen.renderOnTop()
  }, [current]);

  useEffect(() => {
  }, [mailResponse]);

  const openNotification = (message: string, valid: boolean,) => {
    notification.info({
      message: valid ? "Mail je poslat" : "Mail nije poslat",
      icon: valid ? <ExclamationCircleOutlined/> : <CloseCircleOutlined color={"red"}/>,
      description: message,
      placement: 'topRight',
    });
  };

  async function handleMailSending() {
    let resource = {...mailData, calc: calc};
    try {
      handleLoader && handleLoader(Loading.LOADING);
      let response = await api.mail.send(resource);
      setMailResponse(response.data);
      handleLoader && handleLoader(Loading.LOADED);
      openNotification(response.data.message, response.data.valid)
      ;
      console.log(response)
    } catch (e) {
      console.log(e);
      handleLoader && handleLoader(Loading.LOADED);
      openNotification("Greška!", false)

    }
  }

  async function handleCodeCheck() {
    let resource = {...codedata, email: mailData.email};
    try {
      handleLoader && handleLoader(Loading.LOADING);
      let response = await api.code.verify(resource);
      setVerified(response.data.verified);
      handleLoader && handleLoader(Loading.LOADED);
      openNotification(response.data.message, response.data.verified);
      response.data.verified && setMailResponse({...mailResponse, valid: !response.data.verified})
      ;
      console.log(response)
    } catch (e) {
      console.log(e);
      handleLoader && handleLoader(Loading.LOADED);
      openNotification("Greška!", false)
    }
  }

  const hullClass = () => {
    let x = "";
    if (isSame) {
      x = "hull-hide"
    } else {
      x = ""
    }
    return x;
  };

  const subjectSelect = [
    {
      value: TemplatesEnum.BICIKLO,
      item: "Biciklo"
    },
    {
      value: TemplatesEnum.DRUGO,
      item: "Drugo"
    }
  ];
  const inputMultiple = useRef<HTMLInputElement>(null);
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }

    return ([...e.target.files])
  };
  return (
    <>
      <Form
        onFinish={handleFinish}
        scrollToFirstError={true}
        initialValues={initial}
        autoComplete={'off'}
      >
        <div className={"step-two-white"}>
          <div className={"max-width-max"}>
            <h1>Podaci o ugovaraču</h1>
            <div className={"input-group-horizontal"}>
              <InputComponent
                label={"Ime"}
                required
                name={"cFirstName"}
                message={"ime je obavezno!"}
                onChange={(e) => {
                  setMailData({...mailData, ime: e.target.value})
                }}
              />
              <InputComponent
                label={"Prezime"}
                required
                name={"cLastName"}
                message={"prezime je obavezno!"}
                onChange={(e) => {
                  setMailData({...mailData, prezime: e.target.value})
                }}
              />
            </div>
            <div className={"input-group-horizontal"}>
              <InputComponent
                label={"Matični broj"}
                required
                name={"cRegno"}
                validation={(e: any) => util.screen.regnoValidation(e)}
                onChange={(e) => {
                  setMailData({...mailData, jmbg: e.target.value})
                }}
              />
              <InputComponent
                label={"Ulica i broj"}
                required
                name={"cAddress"}
                message={"adresa je obavezna!"}
              />
            </div>
            <SelectComponent
              values={cities}
              label={"Grad"}
              required
              name={"cCity"}
              message={"grad je obavezan!"}
            />
            <SwitchComponent
              label={"Ugovarač i osiguranik su isto lice"}
              offHandleColor={"#ED2939"}
              handleChange={() => setIsSame(!isSame)}
              labelStyle={{color: "#4b4b4b"}}
              name={"contractorInsured"}
            />
            {!isSame &&
            <div className={" " + hullClass()}>
                <h1>Podaci o osiguraniku</h1>
                <div className={"input-group-horizontal"}>
                    <InputComponent
                        label={"Ime"}
                        message={"ime je obavezno!"}
                        required
                        name={"iFirstName"}
                        initialFieldValue={undefined}
                    />
                    <InputComponent
                        label={"Prezime"}
                        required
                        name={"iLastName"}
                        message={"prezime je obavezno"}
                        initialFieldValue={undefined}
                    />
                </div>
                <div className={"input-group-horizontal"}>
                    <InputComponent
                        label={"Matični broj"}
                        required
                        name={"iRegno"}
                        message={"matični broje je obavezan"}
                        validation={(e: any) => util.screen.regnoValidation(e)}
                        initialFieldValue={undefined}
                    />
                    <InputComponent
                        label={"Ulica i broj"}
                        required
                        name={"iAddress"}
                        message={"adresa je obavezna"}
                        initialFieldValue={undefined}
                    />
                </div>
                <SelectComponent values={cities} label={"Grad"}
                                 required
                                 name={"iCity"}
                                 message={"grad je obavezan"}
                                 initialFieldValue={initial?.iCity}
                />
            </div>
            }
          </div>
          <Divider/>
          <h1>Kontakt Podaci</h1>
          <div className={"max-width-medium"}>
            <InputComponent
              label={"Broj telefona ugovarača"}
              required
              name={"phone"}
              message={"broj telefona je obavezan"}
            />
          </div>
        </div>
        <Divider style={{marginBottom: 0}}/>
        <SwitchComponent
          name={'receive_news'}
          label={"Željeli bi smo da vam povremeno šaljemo novosti i ponude emailom, SMS-om, poštom, telefonom i ostalim elektronskim vidovima komunikacije. Lovćen Osiguranje će čuvati Vaše podatke sa najvećom pažnjom i ni pod kojim uslovima ih neće dijeliti sa trećim licima. U svakom momentu možete da povučete svoj pristanak."}
          offHandleColor={"#ED2939"}
          handleChange={(e) => {
            setMailData({...mailData, consent: e});
            handleConsent(e);
          }}
          labelStyle={{color: "#4b4b4b"}}
        />
        <div style={{backgroundColor: "#f5f5f5", padding: "20px 0"}} className={"step-two-white"}>
          <div className={"max-width-medium"}>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 20}}>
              <h4 style={{marginBottom: 0}}>Potvrđivanje email adrese</h4>
              <Tooltip
                title={"Klikom na dugme POŠALJI na vašu adresu e-pošte biće poslata e-pošta koja sadrži kod za potvrdu. Kopirajte ili unesite kod u polje ispod (kod za potvrdu)"}
                placement="left" style={{marginLeft: "10px!important"}}
                color={"#fff"} overlayStyle={{color: "#000", margin: "auto"}}>
                <div style={{marginLeft: "10px"}}><span className={"inputTooltip"}>?</span></div>
              </Tooltip>
            </div>
            <p>Unesite svoj email i kliknite na dugme <strong>pošalji kod</strong></p>
            <div style={{display: "flex", alignItems: "baseline"}}>
              <div style={{display: "flex", flexDirection: "column", alignItems: "baseline", flex: 1}}>
                <InputComponent
                  label={"email adresa"}
                  name={"email"}
                  message={"email je obavezan"}
                  required
                  validation={(e) => util.screen.emailValidation(e)}
                  onChange={(e) => {
                    setMailData({...mailData, email: e.target.value})
                  }}
                />
                {!!mailResponse && mailResponse.valid &&
                <InputComponent
                    label={"verifikacioni kod"}
                    name={"code"}
                    required
                    onChange={(e) => {
                      setCodedata({...codedata, code: e.target.value})
                    }}
                />
                }
              </div>
              <div style={{display: "flex", flexDirection: "column", alignItems: "flex-end",}}>
                <Button className={"button-grey"}
                        style={{padding: "11px 30px!important"}}
                        onClick={handleMailSending}
                >
                  Pošalji kod
                </Button>
                {!!mailResponse && mailResponse.valid &&
                <Button className={"button-grey"}
                        style={{padding: "11px 30px!important"}}
                        onClick={handleCodeCheck}
                >
                    Potvrdi
                </Button>
                }
              </div>
            </div>
          </div>
        </div>
        <Divider style={{marginTop: 0}}/>
        <div className={"step-two-white"}>
          <div className={"max-width-medium"}>
            <h1>Podaci o mikro prevoznom sredstvu</h1>
            <Form.Item dependencies={[["serialNumber"]]} noStyle>
              {() => (
                <Form.Item
                  required
                  name="photo"
                  label="upload fiskalnog računa"
                  valuePropName="fileList"
                  extra="Ukoliko nemate serijski broj dodajte sliku MPS-a"
                  getValueFromEvent={normFile}
                >
                  <input
                    required={requiredPhoto}
                    style={{position: "absolute", opacity: 0}}
                    ref={inputMultiple}
                    name={'photo'}
                    type={"file"}
                    accept={'image/*'}
                    onChange={(e) => {
                      console.log(e);
                      e.target && e.target.files && e.target.files[0] && onPhoto((e.target.files[0]));
                      e.target && e.target.files && e.target.files[0] ? setRequiredSerial(false): setRequiredSerial(true)
                    }}
                  />
                </Form.Item>
              )}
            </Form.Item>

            <div style={{
              display: "flex",
              flexDirection: "column",
            }}>
              <Button className={'button-grey'} onClick={() => inputMultiple.current?.click()}
                      icon={<FileImageOutlined/>}>
                Dodaj iz galerije
              </Button>
            </div>
            <SelectComponent
              name={"itemType"}
              label={"Vrsta MPS"}
              disabled
              values={subjectSelect}
              initialFieldValue={initial?.itemType}
            />
            <InputComponent label={"Marka/Tip"}
                            required
                            name={"model"}
                            message={"model je obavezan"}
            />
            <InputComponent label={"Serijski broj"}
                            required={requiredSerial}
                            name={"serialNumber"}
                            message={"serijski broj je obavezan"}
                            onChange={(e)=>{e.target.value.length>0 ? setRequiredPhoto(false): setRequiredPhoto(true)}}
            />
          </div>
        </div>
        <div className={"step-two-white"}>
          <div className={"max-width-max"}>
            <SwitchComponent
              style={{justifyContent: "end"}}
              label={"Potvrđujem da su navedeni podaci istiniti"}
              offHandleColor={"#ED2939"}
              labelStyle={{color: "#4b4b4b"}}
              required
              message={"Molimo Vas potvrdite"}
              name={"truth"}
            />
            <SwitchComponent
              label={<div>Upoznat sam sa informacijama o zaštiti ličnih podataka u Lovćen Osiguranju, A.D., koje možete pronaći <b><a href={'https://www.lo.co.me/o-nama/zastita-podataka-odlicnosti'} target={'_blank'}  rel={'noreferrer'}>ovdje</a></b></div>}
              offHandleColor={"#ED2939"}
              labelStyle={{color: "#4b4b4b"}}
              required
              message={"Molimo Vas potvrdite"}
              name={"infoProtection"}
            />
            <SwitchComponent
              label={`U skladu sa svrhom Direktive o distribuciji proizvoda osiguranja (IDD) za povećanje zaštite potrošača u distribuciji proizvoda osiguranja, potvrđujem da sam pročitao dokument sa informacijama o proizvodu osiguranja (IPID) za osiguranje koji zaključujem.`}
              offHandleColor={"#ED2939"}
              labelStyle={{color: "#4b4b4b"}}
              required
              message={"Molimo Vas potvrdite"}
              name={"insuranceInfo"}
            />
          </div>
        </div>
        <PrevNextButtons current={current} steps={steps} prev={() => prev()} next={verified}/>
      </Form>
    </>
  )
};

export default StepThree
